<template>
  <v-col v-if="padre.por_local == 1" cols="11" class="d-flex align-top">
    <div v-if="padre.locales.length > 0">
      <v-icon color="primary" style="rotate: 90deg;">fas fa-level-up-alt</v-icon>
    </div>
    <v-card
      v-if="padre.locales.length > 0"
      style="width: 100%;"
      class="ma-2 primary"
      outlined
      flat
    >
      <v-simple-table dense>
        <tbody>
          <tr
            v-for="(item, index) in padre.locales"
            :key="index"
          >
            <td>
              <v-autocomplete
                v-model="item.local"
                :items="all_locales.filter(al => al.empresa == empresa && al.region_id == region && (al.canal == canal || canal == undefined) &&
                                                (!padre.locales.map(cl => cl.local).includes(al.id) || al.id == item.local))"
                item-text="nombre"
                item-value="id"
                class="body-2"
                hide-details
                dense
              ></v-autocomplete>
            </td>
            <td style="width: 25%;">
              <v-text-field
                v-model="item.porcentaje"
                class="body-2"
                type="number"
                suffix="%"
                hide-details
                dense
                @change="$emit('recalcularPorc', 3, item, padre.locales)"
              ></v-text-field>
            </td>
            <td>
              <v-icon
                v-if="roundNumberTF(padre.locales.reduce((sum, cl) => sum + roundNumberTF(cl.porcentaje, 4), 0), 4) > 100"
                title="Imputar diferencia"
                color="success"
                class="mr-2"
                small
                @click="$emit('imputar', item, padre.locales)"
              >
                fas fa-arrow-left
              </v-icon>
              <v-icon
                title="Quitar"
                color="error"
                small
                @click="$emit('quitar', item, padre.locales)"
              >
                fas fa-times-circle
              </v-icon>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <div class="d-flex py-1 px-2 body-2 font-weight-bold white--text">
        Total
        <v-spacer></v-spacer>
        {{ roundNumberTF(padre.locales.reduce((sum, cl) => sum + roundNumberTF(cl.porcentaje, 4), 0), 4) }} %
      </div>
      <div
        v-if="roundNumberTF(padre.locales.reduce((sum, cl) => sum + roundNumberTF(cl.porcentaje, 4), 0), 4) > 100"
        class="d-flex px-4 swalBkg blue-grey--text"
        style="font-size: 12px;"
      >
        <v-spacer></v-spacer>
        ({{ roundNumberTF(100 - padre.locales.reduce((sum, cl) => sum + roundNumberTF(cl.porcentaje, 4), 0), 4) }} %)
      </div>
    </v-card>
  </v-col>
</template>

<script>
import { mapState } from 'vuex'
import { roundNumberTF } from '../../util/utils'

export default {
  data () {
    return {
      roundNumberTF: roundNumberTF
    }
  },
  props: {
    padre: Object,
    empresa: Number,
    region: Number,
    canal: Number
  },
  computed: {
    ...mapState(['all_locales'])
  }
}
</script>